import { useState, useEffect } from "react";
import { Store, TrendingUp, Leaf, ArrowRight, CheckCircle } from "lucide-react";
import { VENDOR_APP_URL } from "@/config/appConfig";

const BuisnessHero = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  //   const stats = [
  //     { icon: Store, value: "2,500+", label: "Partner Stores" },
  //     { icon: Users, value: "100K+", label: "Active Customers" },
  //     { icon: TrendingUp, value: "50L+", label: "Revenue Generated" },
  //   ];

  const benefits = [
    "Increase your online sales",
    "Reach more local customers",
    "Manage orders with ease",
    "Sell Mystery Bags & regular products",
  ];
  return (
    <div className="relative min-h-screen bg-linear-to-br from-emerald-950 via-green-900 to-teal-950 overflow-hidden font-arimo">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute top-20 left-10 w-96 h-96 rounded-full mix-blend-screen filter blur-3xl opacity-20 animate-pulse"
          style={{
            backgroundColor: "#ff9d00",
            transform: `translateY(${scrollY * 0.2}px)`,
          }}
        />
        <div
          className="absolute top-40 right-10 w-lg h-128 bg-orange-400 rounded-full mix-blend-screen filter blur-3xl opacity-20 animate-pulse"
          style={{
            transform: `translateY(${scrollY * 0.3}px)`,
            animationDelay: "1s",
          }}
        />
        <div
          className="absolute -bottom-32 left-1/3 w-96 h-96 bg-amber-400 rounded-full mix-blend-screen filter blur-3xl opacity-20 animate-pulse"
          style={{
            transform: `translateY(${scrollY * 0.15}px)`,
            animationDelay: "2s",
          }}
        />
      </div>

      {/* Grid pattern overlay */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage:
            "linear-gradient(rgba(244, 255, 238, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(244, 255, 238, 0.1) 1px, transparent 1px)",
          backgroundSize: "50px 50px",
        }}
      />

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        <div className="grid lg:grid-cols-2 gap-16 items-center min-h-[calc(100vh-8rem)]">
          {/* Left column - Text content */}
          <div
            className={`space-y-8 transform transition-all duration-1000 ${
              isVisible
                ? "translate-x-0 opacity-100"
                : "-translate-x-12 opacity-0"
            }`}
          >
            {/* Badge */}
            <div
              className="inline-flex items-center gap-2 backdrop-blur-sm px-5 py-2.5 rounded-full text-sm font-medium border-2"
              style={{
                backgroundColor: "rgba(244, 255, 238, 0.1)",
                borderColor: "rgba(244, 255, 238, 0.3)",
                color: "#f4ffee",
              }}
            >
              <Store className="w-4 h-4" />
              <span>
                For Restaurants, Supermarkets, Bakeries & Local Stores
              </span>
            </div>

            {/* Main heading */}
            <h1 className="text-4xl sm:text-6xl lg:text-7xl font-bold text-white leading-tight">
              Sell More,
              <span
                className="block text-transparent bg-clip-text bg-linear-to-r from-green-300 via-emerald-300"
                style={{
                  backgroundImage: `linear-gradient(to right, #f4ffee, #86efac)`,
                }}
              >
                Reach More
              </span>
            </h1>

            {/* Subheading */}
            <p
              className="text-xl leading-relaxed max-w-xl"
              style={{ color: "rgba(244, 255, 238, 0.8)" }}
            >
              Join{" "}
              <span className="font-bold text-orange-500">SMARTLY ORDERS</span>{" "}
              and grow your business by reaching more customers, managing orders
              with ease, and selling everything from meals and groceries to
              everyday essentials and Mystery Bags.
            </p>

            {/* Benefits checklist */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {benefits.map((benefit, idx) => (
                <div
                  key={idx}
                  className={`flex items-center gap-3 transform transition-all duration-500 delay-${
                    idx * 100
                  } ${
                    isVisible
                      ? "translate-x-0 opacity-100"
                      : "-translate-x-4 opacity-0"
                  }`}
                >
                  <CheckCircle
                    className="w-5 h-5 shrink-0"
                    style={{ color: "#f4ffee" }}
                  />
                  <span
                    className="text-sm"
                    style={{ color: "rgba(244, 255, 238, 0.9)" }}
                  >
                    {benefit}
                  </span>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button
                className="group relative px-8 py-4 rounded-xl font-semibold text-lg shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 overflow-hidden"
                style={{
                  backgroundColor: "#f4ffee",
                  color: "#065f46",
                }}
                onClick={() => {
                  window.location.href = VENDOR_APP_URL;
                }}
              >
                <span className="relative z-10 flex items-center justify-center gap-2">
                  Login as Vendor
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </span>
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  style={{
                    backgroundColor: "#e0f5d5",
                  }}
                />
              </button>

              {/* <button
                className="px-8 py-4 backdrop-blur-sm rounded-xl font-semibold text-lg border-2 transform hover:-translate-y-1 transition-all duration-300"
                style={{
                  backgroundColor: "rgba(244, 255, 238, 0.1)",
                  borderColor: "rgba(244, 255, 238, 0.3)",
                  color: "#f4ffee",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor =
                    "rgba(244, 255, 238, 0.2)";
                  e.currentTarget.style.borderColor =
                    "rgba(244, 255, 238, 0.5)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor =
                    "rgba(244, 255, 238, 0.1)";
                  e.currentTarget.style.borderColor =
                    "rgba(244, 255, 238, 0.3)";
                }}
              >
                Schedule Demo
              </button> */}
            </div>

            {/* Stats */}
            {/* <div
              className="grid grid-cols-3 gap-6 pt-8 border-t"
              style={{ borderColor: "rgba(244, 255, 238, 0.1)" }}
            >
              {stats.map((stat, idx) => (
                <div
                  key={idx}
                  className={`transform transition-all duration-700 delay-${
                    idx * 150
                  } ${
                    isVisible
                      ? "translate-y-0 opacity-100"
                      : "translate-y-4 opacity-0"
                  }`}
                >
                  <div className="flex items-center gap-2 mb-2">
                    <stat.icon
                      className="w-5 h-5"
                      style={{ color: "#f4ffee" }}
                    />
                  </div>
                  <div className="text-3xl font-bold text-white">
                    {stat.value}
                  </div>
                  <div
                    className="text-sm"
                    style={{ color: "rgba(244, 255, 238, 0.7)" }}
                  >
                    {stat.label}
                  </div>
                </div>
              ))}
            </div> */}
          </div>

          {/* Right column - Visual element */}
          <div
            className={`relative transform transition-all duration-1000 delay-300 ${
              isVisible
                ? "translate-x-0 opacity-100"
                : "translate-x-12 opacity-0"
            }`}
          >
            <div className="relative max-w-125 mx-auto">
              {/* Main dashboard mockup */}
              <div
                className="relative rounded-2xl overflow-hidden shadow-2xl backdrop-blur-md border p-4 sm:p-6 transform hover:scale-105 transition-transform duration-500"
                style={{
                  backgroundColor: "rgba(244, 255, 238, 0.1)",
                  borderColor: "rgba(244, 255, 238, 0.2)",
                }}
              >
                <div className="space-y-4">
                  {/* Header */}
                  <div className="flex items-center justify-between">
                    <div className="text-white font-semibold text-lg">
                      Vendor Dashboard
                    </div>
                    <div
                      className="px-3 py-1 rounded-full text-xs font-medium border"
                      style={{
                        backgroundColor: "rgba(34, 197, 94, 0.2)",
                        color: "#86efac",
                        borderColor: "rgba(34, 197, 94, 0.3)",
                      }}
                    >
                      Live
                    </div>
                  </div>

                  {/* Stats cards */}
                  <div className="grid grid-cols-2 gap-4">
                    <div
                      className="backdrop-blur-sm rounded-xl p-4 border"
                      style={{
                        backgroundColor: "rgba(244, 255, 238, 0.15)",
                        borderColor: "rgba(244, 255, 238, 0.2)",
                      }}
                    >
                      <div
                        className="text-sm mb-1"
                        style={{ color: "#f4ffee" }}
                      >
                        Revenue
                      </div>
                      <div className="text-white text-3xl font-bold">
                        $12.4K
                      </div>
                      <div className="text-green-400 text-xs mt-1">
                        ↑ 31% this week
                      </div>
                    </div>
                    <div
                      className="backdrop-blur-sm rounded-xl p-4 border"
                      style={{
                        backgroundColor: "rgba(244, 255, 238, 0.15)",
                        borderColor: "rgba(244, 255, 238, 0.2)",
                      }}
                    >
                      <div
                        className="text-sm mb-1"
                        style={{ color: "#f4ffee" }}
                      >
                        Revenue
                      </div>
                      <div className="text-white text-3xl font-bold">
                        $12.4K
                      </div>
                      <div className="text-green-400 text-xs mt-1">
                        ↑ 31% this week
                      </div>
                    </div>
                  </div>

                  {/* Chart visualization */}
                  <div
                    className="backdrop-blur-sm rounded-xl p-4 border"
                    style={{
                      backgroundColor: "rgba(244, 255, 238, 0.05)",
                      borderColor: "rgba(244, 255, 238, 0.1)",
                    }}
                  >
                    <div className="text-white text-sm mb-3">Weekly Sales</div>
                    <div className="flex items-end justify-between gap-2 h-32">
                      {[65, 45, 78, 92, 70, 85, 95].map((height, idx) => (
                        <div
                          key={idx}
                          className="flex-1 rounded-t opacity-80 hover:opacity-100 transition-opacity"
                          style={{
                            height: `${height}%`,
                            background: `linear-gradient(to top, #f4ffee, #86efac)`,
                          }}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Bottom info */}
                  <div
                    className="flex items-center gap-2 rounded-lg p-3 border"
                    style={{
                      backgroundColor: "rgba(34, 197, 94, 0.2)",
                      borderColor: "rgba(34, 197, 94, 0.3)",
                    }}
                  >
                    <Leaf className="w-5 h-5" style={{ color: "#f4ffee" }} />
                    <div
                      className="text-sm"
                      style={{ color: "rgba(244, 255, 238, 0.9)" }}
                    >
                      <span className="font-semibold">247</span> successful
                      orders completed this month
                    </div>
                  </div>
                </div>
              </div>

              {/* Floating notification cards */}
              <div
                className="hidden sm:block absolute sm:-left-6 lg:left-0 xl:-left-16 top-[15%] bg-white rounded-xl shadow-2xl p-3 max-w-40 animate-pulse"
                style={{ animationDuration: "3s" }}
              >
                <div className="flex items-start gap-3">
                  <div
                    className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0"
                    style={{
                      background: `linear-gradient(135deg, #f4ffee, #86efac)`,
                    }}
                  >
                    <CheckCircle className="w-5 h-5 text-emerald-900" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-gray-800">
                      New Order!
                    </div>
                    <div className="text-xs text-gray-600">3 New Orders</div>
                  </div>
                </div>
              </div>

              <div
                className="hidden sm:block absolute sm:-right-6 lg:right-0 xl:-right-16 bottom-[20%] bg-white rounded-xl shadow-2xl p-3 max-w-40 animate-pulse"
                style={{ animationDuration: "3s", animationDelay: "1.5s" }}
              >
                <div className="flex items-start gap-3">
                  <div
                    className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0"
                    style={{
                      background: `linear-gradient(135deg, #fbbf24, #f59e0b)`,
                    }}
                  >
                    <TrendingUp className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-gray-800">
                      Peak Hours
                    </div>
                    <div className="text-xs text-gray-600">High demand now</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom decoration */}
      <div
        className="absolute bottom-0 left-0 right-0 h-px"
        style={{
          background: `linear-gradient(to right, transparent, rgba(244, 255, 238, 0.2), transparent)`,
        }}
      />
    </div>
  );
};

export default BuisnessHero;
